import {
    NewAdditionalTimeModel,
    NewAdditionalTimeModelResponseAPI,
    NewInterruptionModel,
    UpdatedInterruption,
} from '../../../../models';
import { createAdditionalTimeAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

interface CreateAdditionalBody {
    startDate: string;
    endDate: string;
    observations: string;
    employeeIds: (string | number)[];
    startHour: string;
    endHour: string;
    hourTypeId: number | undefined | null;
}

export const InterruptionsAPI = {
    createInterruption: (body: NewInterruptionModel) => {
        return requests
            .post('/jerusalem/api/v2.0.0/interruptions/schedule', body)
            .then((res) => res);
    },

    createAdditional: (body: CreateAdditionalBody) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/interruptions/create-additional-time-interruption',
                body
            )
            .then((response: NewAdditionalTimeModelResponseAPI) =>
                createAdditionalTimeAdapter(response)
            );
    },

    getListInterruptions: (body: {
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
    }) => {
        return requests
            .post('/jerusalem/api/v2.0.0/interruptions/list-interruptions', body)
            .then((res) => res);
    },

    deleteAdditionalTime: (body: { additionalTimeIds: number[] }) => {
        return requests
            .deleteWithBody(
                '/jerusalem/api/v2.0.0/interruptions/delete-additional-time-interruption',
                body
            )
            .then((res) => res);
    },

    deleteInterruptions: (body: { interruptionIds: number[] }) => {
        return requests
            .deleteWithBody('/jerusalem/api/v2.0.0/interruptions', body)
            .then((res) => res);
    },

    updateAdditionalTime: (additionalsToUpdate: NewAdditionalTimeModel[]) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/interruptions/update-additional-time-interruption',
                additionalsToUpdate
            )
            .then((res) => res);
    },

    updateInterruptions: (interruptionsToUpdate: UpdatedInterruption[]) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/interruptions/update-interruptions-time',
                interruptionsToUpdate
            )
            .then((res) => res);
    },
};
